import React, { useState, useEffect, useRef } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import IndiaMap from "./IndiaMapComponent";
import api from "../api";
import ChartContainer from "./ChartContainer";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { staticCardData } from "./StaticData";
import StateSelect from "./StateSelect";
import { Button } from "react-bootstrap";
import { exportDistrictData } from "./exportFile";

const geoUrl = "/map-geo.json";

console.log("geoUrl", geoUrl);
const Dashboard = () => {
  const chartRef = useRef(null);

  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 2 }, (_, i) => currentYear - i); // [2025, 2024, 2023, ...]
  const months = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "long" }),
  ); // ["January", ..., "December"]
  //const currentMonth = currentDate.toLocaleString('default', { month: 'long' }); // e.g. "July"
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [lastChanged, setLastChanged] = useState("");
  const [filters, setFilters] = useState({
    State: "",
    District: "",
    StartYear: "Select Start Year",
    EndYear: "Select End Year",
    StartMonth: "",
    EndMonth: "",
  });
  const [viewMode, setViewMode] = useState("main");
  const [subHeading, setSubHeading] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardData, setCardData] = useState({});
  const [subParentId, setSubParentId] = useState(null);
  const [stateList, setStateList] = useState([]);
  const [isExporting, setIsExporting] = useState(false);

  const cardList = [
    { id: 1, title: "HIV AIDS Epidemiology" },
    {
      id: 2,
      title: "95-95-99 Status",
      endpoint: "/getstatus",
    },
    { id: 3, title: "Category Of Districts", endpoint: "/getcat" },
    { id: 4, title: "Reporting Status of NACP Facilities", endpoint: "/fac" },
    { id: 5, title: "Prevention Services", endpoint: "/getc" },
    { id: 6, title: "STI Management", endpoint: "/getc" },
    {
      id: 7,
      title: "HCTS - ART Linkage Loss",
      endpoint: "/getc",
    },
    { id: 8, title: "Syphilis Management", endpoint: "/getc" },
    { id: 9, title: "VL Test Services (GC)", endpoint: "/getc" },
    { id: 10, title: "NACP to NTEP Referral", endpoint: "/getc" },
    { id: 11, title: "EVTHS" },
    { id: 12, title: "EID", endpoint: "/eid" },
    { id: 13, title: "District CRG", endpoint: "/com" },
    { id: 14, title: "DISHA Field Visit Details", endpoint: "/mon" },
    {
      id: 15,
      // title: "NACO/SACS/Partner Agency Officials Visits",
      title: "Stigma Descrimination Cases Reported",
      endpoint: "/qs",
    },
    {
      id: 16,
      title: "Monthly Meeting Details",
      endpoint: "/meet",
    },
    { id: 17, title: "Complaints Officer Status", endpoint: "/status" },
    { id: 18, title: "Support Requested from SACS", endpoint: "/sup" },
  ];

  const subCardsByParent = {
    1: [
      { id: 101, title: "Adult Prevalence Rate" },
      { id: 102, title: "ANC Prevalence Rate" },
      // { id: 103, title: "District Prevalence" },
      { id: 104, title: "PW Testing Target As per HMIS" },
      { id: 105, title: "PW Estimation as Per SANKALAK" },
      { id: 106, title: "Estimated PLHIV" },
      { id: 107, title: "CLHIV < 15 Years" },
      { id: 108, title: "15 - 24 Years PLHIV" },
      { id: 109, title: "AIDS Related Death" },
      { id: 1010, title: "EVTHS Burden" },
      { id: 1011, title: "Statewise Vertical Transmission %" },
      { id: 1012, title: "95-95-99 Status of State & UT" },
      { id: 103, title: "District Profile", endpoint: "/static" },
      { id: 1013, title: "Category Of Districts" },
    ],
    11: [
      { id: 111, title: "EVTHS Burden", endpoint: "/evths" },
      { id: 112, title: "HMIS Registration", endpoint: "/evths" },
      { id: 113, title: "PW Screened and Tested for HIV", endpoint: "/evths" },
      {
        id: 114,
        title: "PW Reactive and Confirmed Positive",
        endpoint: "/evths",
      },
      {
        id: 115,
        title: "PPW VL Tested and Virally Suppressed",
        endpoint: "/evths",
      },
      {
        id: 116,
        title: "PW Screened for Syphilis and Reactive",
        endpoint: "/evths",
      },
      {
        id: 119,
        title: "EVTHS Services (HIV)",
        endpoint: "/evths",
      },
      // { id: 116, title: "PW With ART", endpoint: "/evths" },
      // { id: 117, title: "PW ART vs New", endpoint: "/evths" },
      // { id: 118, title: "PW VL Tested", endpoint: "/evths" },
    ],
  };

  // const subCardList = [
  //   { id: 111, title: "EVTHS Burden", endpoint: "/evths" },
  //   { id: 112, title: "HMIS Registration", endpoint: "/evths" },
  //   { id: 113, title: "PW Tested", endpoint: "/evths" },
  //   { id: 114, title: "Screened Positive", endpoint: "/evths" },
  //   { id: 115, title: "Confirmed", endpoint: "/evths" },
  //   { id: 116, title: "PW With ART", endpoint: "/evths" },
  //   { id: 117, title: "PW ART vs New", endpoint: "/evths" },
  //   { id: 118, title: "PW VL Tested", endpoint: "/evths" },
  // ];
  // const subFirstCard = [
  //   { id: 101, title: "Prevalence Rate", endpoint: "/" },
  //   { id: 102, title: "ANC Prevalence", endpoint: "/" },
  //   { id: 103, title: "District Prevalence", endpoint: "/" },
  //   { id: 104, title: "Root of Transmission", endpoint: "/" },
  //   { id: 105, title: "Statewise PLHIV", endpoint: "/" },
  //   { id: 106, title: "Statewise peron Being with HIV", endpoint: "/" },
  //   { id: 107, title: "Statewise AIDS Related Death", endpoint: "/" },
  //   {
  //     id: 108,
  //     title: "Statewise Vertical Transmission Percentage",
  //     endpoint: "/",
  //   },
  //   { id: 109, title: "95-95-95 Status", endpoint: "/" },
  // ];

  // useEffect(() => {
  //   if (selectedCard !== null && !isInitialLoad) {
  //     const card =
  //       cardList.find((c) => c.id === selectedCard) ||
  //       subCardList.find((c) => c.id === selectedCard) ||
  //       subFirstCard.find((c) => c.id === selectedCard) ||
  //       subLastCard.find((c) => c.id === selectedCard);
  //     if (card) {
  //       fetchDataForCard(card);
  //     }
  //   }
  // }, [filters, selectedCard]);

  // useEffect(() => {
  //   fetch(geoUrl)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const states = data.features.map((f) => f.properties.st_nm);
  //       setStateList(states.sort());
  //     });
  // }, []);

  useEffect(() => {
    fetch(geoUrl)
      .then((res) => res.json())
      .then((data) => {
        let states = data.features.map((f) => f.properties.st_nm);

        const currentUser = JSON.parse(localStorage.getItem("user"));

        let assignedStates = currentUser?.assigned_state;
        const userType = currentUser?.type; // 0 = internal, 1 = external

        // 🔥 Normalize assigned states
        if (typeof assignedStates === "string") {
          try {
            assignedStates = JSON.parse(assignedStates);
          } catch {
            assignedStates = null;
          }
        }

        const normalize = (s) => s?.toString().trim().toLowerCase();

        // ✅ Apply restriction ONLY for external users
        if (
          userType === 1 &&
          Array.isArray(assignedStates) &&
          assignedStates.length > 0
        ) {
          const allowedSet = new Set(assignedStates.map(normalize));

          states = states.filter((state) => allowedSet.has(normalize(state)));
        }

        // ✅ Sort after filtering
        setStateList(states.sort());
      })
      .catch((err) => console.error("Geo fetch error:", err));
  }, []);

  // 🔥 Re-fetch data when filters or selectedCard change
  useEffect(() => {
    if (!selectedCard) return; // only fetch if a card is selected

    // Find the selected card/subcard details
    const card =
      cardList.find((c) => c.id === selectedCard) ||
      (subParentId &&
        subCardsByParent[subParentId]?.find((c) => c.id === selectedCard));

    if (card) {
      fetchDataForCard(card);
    }
  }, [filters, selectedCard]); // 👈 runs whenever filters or card selection changes

  const fetchDataForCard = async (card) => {
    const { State, District, StartYear,EndYear, StartMonth, EndMonth } = filters;

    if (staticCardData[card.id] && !State) {
      setCardData(staticCardData[card.id]);
      console.log("Using static data for", card.title);
      return;
    }

    const params = { };

    if (State) params.State = State;
    if (District) params.District = District;
    if (StartYear) params.StartYear = StartYear;
    if (EndYear) params.EndYear = EndYear;
    if (StartMonth) params.StartMonth = StartMonth;
    if (EndMonth) params.EndMonth = EndMonth;

    try {
      const res = await api.get(card.endpoint, { params });
      // setCardData((prev) => ({ ...prev, [card.id]: res.data }));
      setCardData(res.data);
      console.log(res.data);
    } catch (err) {
      console.error(`Error fetching ${card.title}:`, err);
      if (err.response) {
        if (err.response.status === 400) {
          console.log("Response 400:", err.response.data);
          toast.warning(err.response.data.error);
        }
      }
      // localStorage.removeItem("token");
      // navigate("/login");
      //setCardData((prev) => ({ ...prev, [card.id]: [] }));
    }
  };

  // const handleCardClick = (card) => {
  //   if (subCardsByParent[card.id]) {
  //     setViewMode("sub");
  //     setSubHeading(card.title);
  //     setSelectedCard(null);
  //   } else {
  //     setSelectedCard(card.id);
  //     setSubHeading("");
  //     fetchDataForCard(card);
  //   }
  // };

  // Watch for selectedCard changes
  // useEffect(() => {
  //   if (selectedCard && chartRef.current) {
  //     chartRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [selectedCard]);

  const handleSubCardClick = (subCard) => {
    setSelectedCard(subCard.id);
    setTimeout(() => {
      if (chartRef.current) {
        chartRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000); // delay to let ChartContainer render
    fetchDataForCard(subCard);
  };

  const handleCardClick = (card) => {
    if (subCardsByParent[card.id]) {
      setViewMode("sub");
      setSubHeading(card.title);
      setSubParentId(card.id); // ✅ track parent card id
      setSelectedCard(null);
    } else {
      setSelectedCard(card.id);
      setSubHeading("");
      setSubParentId(null);
      // fetchDataForCard(card);
    }

    setTimeout(() => {
      if (chartRef.current) {
        chartRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000); // delay to let ChartContainer render
  };

  const [data, setData] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [SelectedStateVal, setSelectedStateVal] = useState(null);
  const [allStatesSelected, setAllStatesSelected] = useState(false);
  const [hoveredState, setHoveredState] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  //const [apiData, setApiData] = useState(null);
  //const data = selectedState ? stateData[selectedState] : null;

  // useEffect(() => {
  //   if (isInitialLoad) {
  //     api
  //       .get(`/getprev`, {
  //         params: {
  //           State: filters.State,
  //           District: filters.District,
  //           Year: filters.Year,
  //           Month: filters.Month,
  //         },
  //       })

  //       .then((res) => {
  //         // if (res.data && res.data.length > 0) {
  //         setData(res.data);
  //         // }
  //         console.log("Initial All-State Data (getsanc):", res.data);
  //       })
  //       .catch((err) => console.error("Initial Load Error (getsanc):", err));
  //   }
  // }, [isInitialLoad]); // only runs once on load

  //working

  // useEffect(() => {
  //   const { State, District, Year, Month } = filters;
  //   if (Year) {
  //     //const State = encodeURIComponent(selectedState);
  //     // Example API endpoint - replace with your actual one
  //     const params = { Year };

  //     if (State) params.State = State;
  //     if (District) params.District = District;
  //     if (Month) params.Month = Month;
  //     const fetchData = async () => {
  //       try {
  //         const response = await api.get(`/getprev`, { params });
  //         console.log("API Response:", response.data);
  //         setData(response.data);
  //       } catch (error) {
  //         console.error("API Error:", error);
  //         setData(null);
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [filters]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsInitialLoad(false);
    setLastChanged(name);
    setFilters({ ...filters, [name]: value });
    //fetchDataForCard();
    console.log("Sending request with filters:", filters);
  };

  const highlightStyle =
    lastChanged === "StartMonth"
      ? {
          border: "2px solid #0073ff",
          // backgroundColor: "#fff3e0",
        }
      : {};

  const stateColors = {
    "Andhra Pradesh": "#C3E2C2",
    "Arunachal Pradesh": "#98A1BC",
    Assam: "#DFD363",
    Bihar: "#DAEAF1",
    Chhattisgarh: "#92C7CF",
    Goa: "#A2AABD",
    Gujarat: "#B5828C",
    Haryana: "#A7C1A8",
    Himachal_Pradesh: "#D1D8BE",
    Jharkhand: "#CD5656",
    Karnataka: "#BF9264",
    Kerala: "#97866A",
    // Karnataka: "#BF9264",
    // Kerala: "#97866A",
    "Madhya Pradesh": "#EDE8CC",
    Maharashtra: "#ECB2BA",
    Mumbai: "#FADOC4",
    Manipur: "#B9B28A",
    Meghalaya: "#E9EDC9",
    Mizoram: "#819A91",
    Nagaland: "#FFB4A2",
    Odisha: "#FFCDB2",
    Punjab: "#FADA7A",
    Rajasthan: "#C8AAAA",
    Sikkim: "#9F8383",
    "Tamil Nadu": "#89A882",
    Telangana: "#B3C8CF",
    Tripura: "#FFF7DA",
    "Uttar Pradesh": "#FFB38E",
    Uttarakhand: "#D6C0B3",
    "West Bengal": "#B7B7B7",

    // Union Territories
    "Andaman and Nicobar Islands": "#295798",
    Chandigarh: "#A1D6B2",
    "Dadra and Nagar Haveli and Daman and Diu": "#COC78C",
    Delhi: "#A6B37D",
    "Jammu and Kashmir": "#E8E4DD",
    Ladakh: "#CBDCEB",
    Lakshadweep: "#D37676",
    Puducherry: "#CCD3CA",
  };

  const stateLabels = {
    "Andhra Pradesh": [80.5, 15.9],
    "Arunachal Pradesh ": [94.7, 28.1],
    Assam: [92.9, 26.2],
    Bihar: [85.3, 25.8],
    Chhattisgarh: [82.0, 21.3],
    Goa: [74.0, 15.4],
    Gujarat: [71.2, 22.3],
    Haryana: [76.1, 29.2],
    Himachal_Pradesh: [77.1, 31.8],
    Jharkhand: [85.5, 23.6],
    Karnataka: [76.1, 15.3],
    Kerala: [76.2, 10.1],
    "Madhya Pradesh": [78.8, 23.3],
    Maharashtra: [75.5, 19.5],
    Mumbai: [73.9, 18.8],
    Manipur: [93.9, 24.7],
    Meghalaya: [91.3, 25.5],
    Mizoram: [92.9, 23.2],
    Nagaland: [94.2, 26.0],
    Odisha: [84.8, 20.4],
    Punjab: [75.4, 30.8],
    Rajasthan: [73.0, 26.5],
    Sikkim: [88.5, 27.3],
    "Tamil Nadu": [78.7, 10.8],
    Telangana: [79.2, 17.8],
    Tripura: [91.6, 23.8],
    "Uttar Pradesh": [80.9, 27.0],
    Uttarakhand: [79.0, 30.1],
    "West Bengal": [88.3, 23.0],
    // Union Territories
    Delhi: [77.2, 28.6],
    "Jammu and Kashmir": [75.5, 33.8],
    Ladakh: [78.0, 34.5],
    Chandigarh: [76.9, 31.2],
    Puducherry: [79.8, 11.9],
    "Andaman and Nicobar Islands": [92.7, 11.7],
    Lakshadweep: [72.8, 10.6],
    // "Dadra and Nagar Haveli and Daman and Diu": [73.0, 20.2],
  };
  console.log("CHNAAA:", lastChanged);

  return (
    <div>
      <div>
        <div className="mapFiltersBar">
          <h5>Dashboard</h5>
          <div className="d-flex justify-content-start gap-3 p-3">
            <select
              className="form-select"
              name="StartYear"
              value={filters.StartYear}
              onChange={handleChange}
              style={{ width: "200px" }}
            >
              <option value="">Select Start Year</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <span style={{color: "#de2222" }}>*</span>
            <select
              className="form-select"
              name="EndYear"
              value={filters.EndYear}
              onChange={handleChange}
              style={{ width: "200px" }}
            >
              <option value="">Select End Year</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <span style={{color: "#de2222" }}>*</span>
            <select
              className="form-select"
              name="StartMonth"
              value={filters.StartMonth}
              onChange={handleChange}
              style={{ width: "200px" }}
            >
              <option value="">Start Month</option>
              {months.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
            <select
              className="form-select"
              name="EndMonth"
              value={filters.EndMonth}
              onChange={handleChange}
              style={{ width: "200px", ...highlightStyle }}
            > 
              <option value="">End Month</option>
              {months.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
            <StateSelect
              stateList={stateList}
              selectedState={selectedState}
              setSelectedState={setSelectedState}
              setFilters={setFilters}
            />

            {/* <Button
              variant="success"
              onClick={() =>
                exportDistrictData({
                  Year: filters.Year,
                  Month: filters.StartMonth,
                  State: filters.State,
                })
              }
            >
              Export to Excel
            </Button> */}
            {/* <Button
              variant="success"
              onClick={async () => {
                setIsExporting(true);
                try {
                  await exportDistrictData({
                    Year: filters.Year,
                    Month: filters.StartMonth,
                    State: filters.State,
                  });
                } finally {
                  setIsExporting(false);
                }
              }}
              disabled={isExporting}
            >
              {isExporting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Exporting...
                </>
              ) : (
                <>
                  <i className="bi bi-file-earmark-excel me-2"></i>
                  Export to Excel
                </>
              )}
            </Button> */}

            {/* <select
              className="form-select"
              value={selectedState}
              onChange={(e) => {
                const selectedOptions = Array.from(
                  e.target.selectedOptions,
                  (opt) => opt.value
                );
                setSelectedState(selectedOptions);
                setFilters((prev) => ({
                  ...prev,
                  State: selectedOptions.join(","),
                }));
              }}
              style={{ width: "200px" }}
            >
              <option value="">Select State</option>
              {stateList.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select> */}
            {/* <button
              className="btn btn-dark border-0"
              style={{
                backgroundColor: allStatesSelected ? "#6271DD" : "",
                color: allStatesSelected ? "#fff" : "",
                border: "1px solid #ccc",
                width: "180px",
              }}
              onClick={() => {
                setSelectedState([]);
                selectedState.includes("something");

                setAllStatesSelected(true);
                setFilters((prev) => ({ ...prev, State: "" }));
              }}
            >
              All States
            </button> */}
          </div>
        </div>

        <div className="row">
          <div className="col-lg-7">
            <div className="card hptCard mt-4 border-0">
              <ComposableMap
                projection="geoMercator"
                projectionConfig={{ scale: 1000, center: [85, 23] }}
                width={800}
                //height={600}
                style={{ width: "100%", height: "985px" }}
              >
                <Geographies geography={geoUrl}>
                  {({ geographies }) =>
                    geographies.map((geo) => (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        // onClick={() => {
                        //   console.log(
                        //     "Clicked:",
                        //     geo.properties.st_nm,
                        //     geo.properties.st_val
                        //   );

                        //   // setSelectedState(geo.properties.st_nm || "Unknown");
                        //   // setSelectedStateVal(geo.properties.st_val || "Unknown");
                        //   const newState = geo.properties.st_nm || "Unknown";
                        //   const newStateVal =
                        //     geo.properties.st_val || "Unknown";

                        //   // Set the selected state values
                        //   setSelectedState(newState);
                        //   setSelectedStateVal(newStateVal);
                        //   setAllStatesSelected(false);

                        //   console.log("State:", selectedState);
                        //   handleChange({
                        //     target: {
                        //       name: "State",
                        //       value: newState,
                        //     },
                        //   });
                        // }}
                        onClick={() => {
                          const newState = geo.properties.st_nm || "Unknown";

                          setSelectedState((prev) => {
                            if (prev.some((s) => s.value === "")) {
                              const updated = [
                                { value: newState, label: newState },
                              ];
                              setFilters((prevFilters) => ({
                                ...prevFilters,
                                State: newState,
                              }));
                              return updated;
                            }
                            let updated;
                            // if (prev.includes(newState)) {
                            //   // If already selected, remove it
                            //   updated = prev.filter((s) => s !== newState);
                            // } else {
                            //   // Otherwise, add it
                            //   updated = [...prev, newState];
                            // }
                            if (prev.some((s) => s.value === newState)) {
                              // if already selected → remove it
                              updated = prev.filter(
                                (s) => s.value !== newState,
                              );
                            } else {
                              // otherwise add it
                              updated = [
                                ...prev,
                                { value: newState, label: newState },
                              ];
                            }

                            // Update filters with comma-separated string
                            setFilters((prevFilters) => ({
                              ...prevFilters,
                              // State: updated.join(","),
                              State: updated.map((s) => s.value).join(","),
                            }));

                            return updated;
                          });

                          setAllStatesSelected(false);
                        }}
                        onMouseEnter={(e) => {
                          // setHoveredState(geo.properties.st_nm || "Unknown");
                        }}
                        onMouseMove={(e) => {
                          setTooltipPosition({ x: e.clientX, y: e.clientY });
                        }}
                        onMouseLeave={() => {
                          // setHoveredState(null);
                        }}
                        style={{
                          default: {
                            fill:
                              // selectedState === geo.properties.st_nm
                              // selectedState.includes(geo.properties.st_nm)
                              selectedState.some(
                                (s) => s.value === geo.properties.st_nm,
                              ) || selectedState.some((s) => s.value === "")
                                ? "#00a084"
                                : stateColors[geo.properties.st_nm] ||
                                  "#D6D6DA",
                            stroke: "#607D8B",
                            strokeWidth: 0.75,
                          },
                          hover: {
                            fill: "#E42",
                            stroke: "#607D8B",
                            strokeWidth: 1,
                          },
                          pressed: {
                            fill: "#00a084",
                            stroke: "#607D8B",
                            strokeWidth: 1,
                            outline: "none",
                          },
                        }}
                      />
                    ))
                  }
                </Geographies>
                {Object.entries(stateLabels).map(([name, coords]) => {
                  // shrink font size if name is too long
                  const fontSize =
                    name.length > 20 ? 7 : name.length > 12 ? 8 : 10;

                  // wrap text if too long (split into multiple words)
                  const words = name.split(" ");
                  const maxWordsPerLine = 3;
                  const lines = [];

                  for (let i = 0; i < words.length; i += maxWordsPerLine) {
                    lines.push(words.slice(i, i + maxWordsPerLine).join(" "));
                  }

                  return (
                    <Marker key={name} coordinates={coords}>
                      <text
                        textAnchor="middle"
                        alignmentBaseline="middle"
                        style={{
                          fontFamily: "sans-serif",
                          fontWeight: "bold",
                          fontSize: 9,
                          fill: "#333",
                          cursor: "pointer", // show hand on hover
                          pointerEvents: "auto", // enable clicks
                        }}
                        onClick={() => {
                          // same logic you already use in Geography onClick
                          setSelectedState((prev) => {
                            if (prev.some((s) => s.value === "ALL")) {
                              const updated = [{ value: name, label: name }];
                              setFilters((prevFilters) => ({
                                ...prevFilters,
                                State: name,
                              }));
                              return updated;
                            }
                            let updated;
                            if (prev.some((s) => s.value === name)) {
                              // remove if already selected
                              updated = prev.filter((s) => s.value !== name);
                            } else {
                              // add if not selected
                              updated = [...prev, { value: name, label: name }];
                            }

                            setFilters((prevFilters) => ({
                              ...prevFilters,
                              State: updated.map((s) => s.value).join(","),
                            }));

                            return updated;
                          });

                          setAllStatesSelected(false);
                        }}
                      >
                        {name}
                      </text>
                    </Marker>
                  );
                })}
              </ComposableMap>
            </div>
          </div>

          {hoveredState && (
            <div
              style={{
                position: "fixed",
                top: tooltipPosition.y + 10,
                left: tooltipPosition.x + 10,
                backgroundColor: "rgba(0, 0, 0, 0.75)",
                color: "#fff",
                padding: "4px 8px",
                borderRadius: "4px",
                pointerEvents: "none",
                fontSize: "0.85rem",
                zIndex: 1000,
                width: "150px",
              }}
            >
              {hoveredState}
            </div>
          )}

          <div
            className="col-lg-5"
            style={{
              position: "sticky",
              top: "140px",
              alignSelf: "flex-start",
              zIndex: 1030,
            }}
          >
            {/* <strong>Selected State:</strong>
          <p>{selectedState || "Click a state"}</p> */}
            <div class="card hptCard mt-4 border-0">
              <div class="card-header">
                <div class="headnumText justify-content-between">
                  <div class="cardTitle">
                    <h5>DISHA</h5>
                    <p>
                      {" "}
                      Monitoring Report{subHeading ? ` - ${subHeading}` : ""}
                    </p>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <div class="chart">
                  <div className="row g-3">
                    {viewMode === "main" ? (
                      cardList.map((card) => (
                        <div className="col-md-6 col-sm-4 col-6" key={card.id}>
                          <div
                            style={{
                              textAlign: "center",

                              justifyContent: "center",
                            }}
                            className={`filterList ${
                              selectedCard === card.id
                                ? "bg-success text-white"
                                : ""
                            }`}
                            onClick={() => handleCardClick(card)}
                          >
                            <h5 className="card-title">{card.title}</h5>
                            {/* <p className="card-text">Click to view more...</p> */}
                          </div>
                        </div>
                      ))
                    ) : (
                      <>
                        {(subCardsByParent[subParentId] || []).map((sub) => (
                          <div className="col-md-6 col-sm-4 col-6" key={sub.id}>
                            <div
                              style={{
                                textAlign: "center",

                                justifyContent: "center",
                              }}
                              className={`filterList ${
                                selectedCard === sub.id
                                  ? "bg-success text-white"
                                  : ""
                              }`}
                              onClick={() => handleSubCardClick(sub)}
                            >
                              <h5 className="card-title">{sub.title}</h5>
                              {/* <p className="card-text">Click to view more...</p> */}
                            </div>
                          </div>
                        ))}
                        <div className="col-12">
                          <button
                            className="btn btn-secondary mt-3"
                            onClick={() => {
                              setViewMode("main");
                              setSubHeading("");
                              setSubParentId(null);
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  {/* <div className="row g-3">
              {cardList.map((card) => (
                <div className="col-md-6 col-sm-4 col-6" key={card.id}>
                  <div
                    className={`filterList  ${
                      selectedCard === card.id ? "bg-success text-white" : ""
                    }`}
                    onClick={() => handleCardClick(card)}
                  >
                    
                      <h5 className="card-title">{card.title}</h5>
                      <p className="card-text">Click to view more...</p>
                    
                  </div>
                    </div>
                  ))}
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mt-2 p-3 bg-light rounded">
        <h1>{selectedCard}</h1>
        <pre>{JSON.stringify(cardData, null, 2)}</pre>
      </div> */}
      <div ref={chartRef} style={{ paddingTop: "100px", marginTop: "-100px" }}>
        <ChartContainer
          id={selectedCard}
          data={cardData}
          filters={filters}
          selectedState={selectedState}
        />
      </div>
    </div>
  );
};

export default Dashboard;
